import { CanActivateFn } from '@angular/router';
import { UserModel } from '@models/user.model';
import { createRoleGuard } from './role-guard.utils';

export const operatorRoleGuard: CanActivateFn = () =>
  createRoleGuard({
    allowedRole: UserModel.Role.OPERATOR,
    redirectByRole: {
      [UserModel.Role.USER]: UserModel.Role.OPERATOR,
    },
    fallbackRedirectRole: UserModel.Role.DEVELOPER,
  });
